import React from 'react'
import { Container, Grid, Paper, Typography, Button, Box, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import styles from "./vendorprofile/myprofile.module.css"
import VendorProfileMenu from '../Components/vendorprofilemenu/VendorProfileMenu';
import DashCards from '../Components/DashCards';

const StyledGrid = styled(Grid)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: theme.shape.borderRadius,
}));


const VendorNotifications = () => {
    return (
        <>
            <div className={styles.myprofile}>
                <div className={styles.promenu}>
                    <VendorProfileMenu />
                </div>
                <div style={{ display: 'flex', gap: '20px', flexDirection: "column" }}>
                    <DashCards />
                    <div style={{ display: 'flex', gap: '20px' }}>
                        <Paper>
                            <Grid item sx={{ padding: '10px 20px 0px 20px' }}>
                                <Typography sx={{ fontSize: "16px", color: '#1A1A1A', fontWeight: '600' }}>  Notifications </Typography>
                            </Grid>
                            <Box sx={{ padding: '0px 20px' }}>
                                <StyledGrid container sx={{ display: 'flex', flexDirection: "column", alignItems: "flex-start", margin: "16px 0px" }}>
                                    <Grid sx={{ display: 'flex', alignItems: 'center', marginBottom: "10px" }}>
                                        <Typography sx={{ marginRight: '6px', width: '10px', height: '10px', borderRadius: "50px", background: "#512DA8" }}></Typography>
                                        <Typography sx={{ fontSize: "14px", color: '#1A1A1A', }}>
                                            Dummy content can be added as here
                                        </Typography>
                                    </Grid>
                                    <Grid item sx={{ display: 'flex', gap: 1, marginLeft: '16px', marginBottom: "10px" }}>
                                        <Button sx={{ color: '#fff', fontSize: "12px", textTransform: 'capitalize', background: '#512DA8' }}  >Accept</Button>
                                        <Button sx={{ color: '#3C4257', fontSize: "12px", textTransform: 'capitalize', border: '1px solid #DDDEE1' }}  >Reject</Button>
                                    </Grid>
                                    <Typography sx={{ fontSize: "14px", color: '#A5ACB8', marginLeft: '16px' }}>
                                        Today at 9:42 AM
                                    </Typography>
                                </StyledGrid >
                            </Box>
                            <Divider sx={{ mb: 1 }} />
                            <Box sx={{ padding: '0px 20px' }}>
                                <StyledGrid container sx={{ display: 'flex', flexDirection: "column", alignItems: "flex-start", margin: "16px 0px" }}>
                                    <Grid sx={{ display: 'flex', alignItems: 'center', marginBottom: "10px" }}>
                                        <Typography sx={{ marginRight: '6px', width: '10px', height: '10px', borderRadius: "50px", background: "#512DA8" }}></Typography>
                                        <Typography sx={{ fontSize: "14px", color: '#1A1A1A', }}>
                                            Ray Arnold has created an excess inventory request that is due in 3 weeks for approval
                                        </Typography>
                                    </Grid>

                                    <Grid item sx={{ display: 'flex', gap: 1, marginLeft: '16px', marginBottom: "10px" }}>
                                        <Button sx={{ color: '#3C4257', fontSize: "12px", textTransform: 'capitalize', border: '1px solid #DDDEE1' }}  >View</Button>
                                    </Grid>
                                    <Typography sx={{ fontSize: "14px", color: '#A5ACB8', marginLeft: '16px' }}>
                                        Today at 9:42 AM
                                    </Typography>
                                </StyledGrid >
                            </Box>
                            <Divider sx={{ mb: 1 }} />
                            <Box sx={{ padding: '0px 20px' }}>
                                <StyledGrid container sx={{ display: 'flex', flexDirection: "column", alignItems: "flex-start", margin: "16px 0px" }}>
                                    <Grid sx={{ display: 'flex', alignItems: 'center', marginBottom: "10px" }}>
                                        <Typography sx={{ marginRight: '6px', width: '10px', height: '10px', borderRadius: "50px", background: "#512DA8" }}></Typography>
                                        <Typography sx={{ fontSize: "14px", color: '#1A1A1A', }}>
                                            Ray Arnold has created an excess inventory request that is due in 3 weeks for approval
                                        </Typography>
                                    </Grid>

                                    <Grid item sx={{ display: 'flex', gap: 1, marginLeft: '16px', marginBottom: "10px" }}>
                                        <Button sx={{ color: '#fff', fontSize: "12px", textTransform: 'capitalize', background: '#512DA8' }}  >Accept</Button>
                                        <Button sx={{ color: '#3C4257', fontSize: "12px", textTransform: 'capitalize', border: '1px solid #DDDEE1' }}  >Reject</Button>
                                    </Grid>
                                    <Typography sx={{ fontSize: "14px", color: '#A5ACB8', marginLeft: '16px' }}>
                                        Today at 9:42 AM
                                    </Typography>
                                </StyledGrid >
                            </Box>
                            <Divider sx={{ mb: 1 }} />
                            <Box sx={{ padding: '0px 20px' }}>
                                <StyledGrid container sx={{ display: 'flex', flexDirection: "column", alignItems: "flex-start", margin: "16px 0px" }}>
                                    <Grid sx={{ display: 'flex', alignItems: 'center', marginBottom: "10px" }}>
                                        <Typography sx={{ marginRight: '6px', width: '10px', height: '10px', borderRadius: "50px", background: "#512DA8" }}></Typography>
                                        <Typography sx={{ fontSize: "14px", color: '#1A1A1A', }}>
                                            Dummy content can be added as here
                                        </Typography>
                                    </Grid>

                                    <Typography sx={{ fontSize: "14px", color: '#A5ACB8', marginLeft: '16px' }}>
                                        Today at 9:42 AM
                                    </Typography>
                                </StyledGrid >
                            </Box>
                            <Divider sx={{ mb: 1 }} />
                            <Box sx={{ padding: '0px 20px' }}>
                                <StyledGrid container sx={{ display: 'flex', flexDirection: "column", alignItems: "flex-start", margin: "16px 0px" }}>
                                    <Grid sx={{ display: 'flex', alignItems: 'center', marginBottom: "10px" }}>
                                        <Typography sx={{ marginRight: '6px', width: '10px', height: '10px', borderRadius: "50px", background: "#512DA8" }}></Typography>
                                        <Typography sx={{ fontSize: "14px", color: '#1A1A1A', }}>
                                            Dummy content can be added as here
                                        </Typography>
                                    </Grid>

                                    <Grid item sx={{ display: 'flex', gap: 1, marginLeft: '16px', marginBottom: "10px" }}>
                                        <Button sx={{ color: '#fff', fontSize: "12px", textTransform: 'capitalize', background: '#512DA8' }}  >Accept</Button>
                                        <Button sx={{ color: '#3C4257', fontSize: "12px", textTransform: 'capitalize', border: '1px solid #DDDEE1' }}  >Reject</Button>
                                    </Grid>
                                    <Typography sx={{ fontSize: "14px", color: '#A5ACB8', marginLeft: '16px' }}>
                                        Today at 9:42 AM
                                    </Typography>
                                </StyledGrid >
                            </Box>
                            <Divider sx={{ mb: 1 }} />
                            <Button sx={{ color: '#512DA8', fontSize: "14px", textTransform: 'capitalize', marginLeft: '10px' }}  >View all</Button>

                        </Paper>
                        <Paper sx={{ height: "fit-content" }}>
                            <Grid item sx={{ padding: '10px 20px 0px 20px' }}>
                                <Typography sx={{ fontSize: "16px", color: '#1A1A1A', fontWeight: '600' }}>  Recent  activites </Typography>
                            </Grid>
                            <Box sx={{ padding: '0px 20px' }}>
                                <StyledGrid container sx={{ display: 'flex', flexDirection: "column", alignItems: "flex-start", margin: "16px 0px" }}>
                                    <Grid sx={{ display: 'flex', alignItems: 'center', marginBottom: "10px" }}>
                                        <Typography sx={{ marginRight: '6px', width: '10px', height: '10px', borderRadius: "50px", background: "#512DA8" }}></Typography>
                                        <Typography sx={{ fontSize: "14px", color: '#1A1A1A', }}>
                                            Dummy content can be added as here
                                        </Typography>
                                    </Grid>
                                    <Typography sx={{ fontSize: "14px", color: '#A5ACB8', marginLeft: '16px' }}>
                                        Today at 9:42 AM
                                    </Typography>
                                </StyledGrid >
                            </Box>
                            <Divider sx={{ mb: 1 }} />
                            <Box sx={{ padding: '0px 20px' }}>
                                <StyledGrid container sx={{ display: 'flex', flexDirection: "column", alignItems: "flex-start", margin: "16px 0px" }}>
                                    <Grid sx={{ display: 'flex', alignItems: 'center', marginBottom: "10px" }}>
                                        <Typography sx={{ marginRight: '6px', width: '10px', height: '10px', borderRadius: "50px", background: "#512DA8" }}></Typography>
                                        <Typography sx={{ fontSize: "14px", color: '#1A1A1A', }}>
                                            Ray Arnold has created an excess inventory request that is due in 3 weeks for approval
                                        </Typography>
                                    </Grid>
                                    <Typography sx={{ fontSize: "14px", color: '#A5ACB8', marginLeft: '16px' }}>
                                        Today at 9:42 AM
                                    </Typography>
                                </StyledGrid >
                            </Box>
                            <Divider sx={{ mb: 1 }} />
                            <Box sx={{ padding: '0px 20px' }}>
                                <StyledGrid container sx={{ display: 'flex', flexDirection: "column", alignItems: "flex-start", margin: "16px 0px" }}>
                                    <Grid sx={{ display: 'flex', alignItems: 'center', marginBottom: "10px" }}>
                                        <Typography sx={{ marginRight: '6px', width: '10px', height: '10px', borderRadius: "50px", background: "#512DA8" }}></Typography>
                                        <Typography sx={{ fontSize: "14px", color: '#1A1A1A', }}>
                                            Ray Arnold has created an excess inventory request that is due in 3 weeks for approval
                                        </Typography>
                                    </Grid>
                                    <Typography sx={{ fontSize: "14px", color: '#A5ACB8', marginLeft: '16px' }}>
                                        Today at 9:42 AM
                                    </Typography>
                                </StyledGrid >
                            </Box>
                            <Divider sx={{ mb: 1 }} />
                            <Box sx={{ padding: '0px 20px' }}>
                                <StyledGrid container sx={{ display: 'flex', flexDirection: "column", alignItems: "flex-start", margin: "16px 0px" }}>
                                    <Grid sx={{ display: 'flex', alignItems: 'center', marginBottom: "10px" }}>
                                        <Typography sx={{ marginRight: '6px', width: '10px', height: '10px', borderRadius: "50px", background: "#512DA8" }}></Typography>
                                        <Typography sx={{ fontSize: "14px", color: '#1A1A1A', }}>
                                            Dummy content can be added as here
                                        </Typography>
                                    </Grid>

                                    <Typography sx={{ fontSize: "14px", color: '#A5ACB8', marginLeft: '16px' }}>
                                        Today at 9:42 AM
                                    </Typography>
                                </StyledGrid >
                            </Box>
                            <Divider sx={{ mb: 1 }} />
                            <Box sx={{ padding: '0px 20px' }}>
                                <StyledGrid container sx={{ display: 'flex', flexDirection: "column", alignItems: "flex-start", margin: "16px 0px" }}>
                                    <Grid sx={{ display: 'flex', alignItems: 'center', marginBottom: "10px" }}>
                                        <Typography sx={{ marginRight: '6px', width: '10px', height: '10px', borderRadius: "50px", background: "#512DA8" }}></Typography>
                                        <Typography sx={{ fontSize: "14px", color: '#1A1A1A', }}>
                                            Dummy content can be added as here
                                        </Typography>
                                    </Grid>
                                    <Typography sx={{ fontSize: "14px", color: '#A5ACB8', marginLeft: '16px' }}>
                                        Today at 9:42 AM
                                    </Typography>
                                </StyledGrid >
                            </Box>
                            <Divider sx={{ mb: 1 }} />
                            <Button sx={{ color: '#512DA8', fontSize: "14px", textTransform: 'capitalize', marginLeft: '10px' }}  >View all</Button>

                        </Paper>
                    </div>
                </div>
            </div>
        </>
    )
}

export default VendorNotifications